import React, { useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  CloseSalesOrderApi,
  GetAllSalesByStoreID,
  // GetAllStores,
  // PrintPackingListApi,
  // PrintProformaInvoiceApi,
  PrintSalesOrderApi,
  // TransferSalesOrderApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
// import PopupSelectField from "../../components/PopupSelectField";
import DataGrid from "../../components/DataGrid";

const Sales = () => {
  const { storeG, userPermID } = useStateContext();
  const [AllOrders, setAllOrders] = useState("");
  const [order, setOrder] = useState(null);
  // const [storeOptions, setStoreOptions] = useState([]);
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const PartGridactiveStatus = (props) => (
    <div className="flex gap-2 justify-center items-center text-white font-bold">
      <label
        className={`py-2 px-2 rounded-2xl ${props.so_status === "Closed" ? "text-gray-800" : props.so_status === "Canceled" ? "text-red-700" : props.so_status === "Hold" ? "text-amber-900" : props.so_status === "Open" ? "text-blue-800" : "text-green-800"}`}
      >
        {props.so_status}
      </label>
    </div>
  );
  const soIdTemp = (props) => <div>{`${props.quote_sale}${props.so_id}`}</div>;

  const customersGrid = [
    {
      field: "quote_sale",
      template: soIdTemp,
      headerText: "SO #",
      minWidth: "110",
      width: "110",
      maxWidth: "120",
      textAlign: "right",
    },
    {
      field: "quote_date",
      headerText: "Quote Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "sale_date",
      headerText: "Sales Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "customer",
      headerText: "Customer",
      minWidth: "160",
      width: "180",
      maxWidth: "360",
      textAlign: "left",
    },
    {
      field: "customer_po_no",
      headerText: "Cust PO",
      minWidth: "130",
      width: "140",
      maxWidth: "180",
      textAlign: "right",
    },
    {
      field: "so_status",
      headerText: "Status",
      template: PartGridactiveStatus,
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "payment_status",
      headerText: "Payment Status",
      minWidth: "180",
      width: "180",
      maxWidth: "185",
      textAlign: "left",
    },
    {
      field: `total_price`,
      headerText: "Total Amt",
      format: "C2",
      minWidth: "135",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: `amount_paid`,
      headerText: "Amt Rcvd",
      format: "C2",
      minWidth: "140",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: "amount_pending",
      format: "C2",
      headerText: "Amt Pend",
      minWidth: "140",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: "user_note",
      headerText: "User Note",
      minWidth: "140",
      width: "160",
      maxWidth: "360",
      textAlign: "left",
    },
  ];

  const handlestatusClick = async (event) => {
    event.preventDefault();
    if (order) {
      TimeoutUtility.resetTimeout();
      if (order.so_status === "Open") {
        if (
          !order.full_shipped &&
          !window.confirm(
            `Order is not completely Shipped!\nStill want to continue?`,
          )
        )
          return;
        if (
          order.amount_paid < order.total_price &&
          !window.confirm(`Order is not Paid in Full!\nStill want to continue?`)
        )
          return;
        try {
          const resp = await CloseSalesOrderApi(order.so_id);
          if (resp.success)
            showSuccessToast("Success!", "Sale Order Closed successfully.");
          else {
            showErrorToast(
              "Error!",
              "Failed to Close Sale Order\n\n" + resp.message,
            );
            return;
          }
        } catch (err) {
          showErrorToast("Error!", "Failed to update sale order Status.");
        }
        window.location.reload();
      } else {
        showInfoToast("Info!", "Order is already Closed.");
        return;
      }
    } else showInfoToast("Info!", "Please select sale order!");
  };

  const handleAddOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order && window.confirm(`Do you want to copy the selected Order?`))
      localStorage.setItem("copyOrder", order.so_id);
    window.open(`/Sales/AddSalesOrder`, "_blank");
  };

  const handleEditOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) window.open(`/Sales/EditSalesOrder/${order.so_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Order!");
  };

  const handleBuildSheetClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order.sys_part_id)
      window.open(`/Sales/BuildSheet/${order.sys_part_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Order with System!");
  };

  // const handleTransferOrderClick = async (event) => {
  //   TimeoutUtility.resetTimeout();
  //   event.preventDefault();
  //   if (order) {
  //     if (order.any_shipped)
  //       showErrorToast(
  //         "Error!",
  //         "This Order is already shipped and therefore cannot be transfered to another store!",
  //       );
  //     else if (order.amount_paid > 0)
  //       showErrorToast(
  //         "Error!",
  //         "This Order has Amount Rcvd and therefore cannot be transfered to another store!",
  //       );
  //     else setIsDialogOpen(true);
  //   } else showInfoToast("Info!", "Please Select Order!");
  // };

  // const handleTransferOrderStore = async (store) => {
  //   TimeoutUtility.resetTimeout();
  //   if (!order) {
  //     showErrorToast("Error!", "Please select an order to transfer!");
  //     return;
  //   }
  //   if (!store || !store.value) {
  //     showErrorToast("Error!", "Please select a store to transfer the order!");
  //     return;
  //   }
  //   if (store.value === order.store_id) {
  //     showErrorToast(
  //       "Error!",
  //       "This Transfer Order cannot be processed as the selected store is the same as the original store!\n\nTry again after selecting a different store.",
  //     );
  //     return;
  //   }
  //   if (
  //     window.confirm(
  //       `Are you sure you want to transfer this Order to ${store.label}?`,
  //     )
  //   ) {
  //     try {
  //       const resp = await TransferSalesOrderApi(order.so_id, store.value);
  //       if (resp.success) {
  //         showSuccessToast("Success!", "Order transfered successfully!");
  //         window.location.reload();
  //       } else
  //         showErrorToast("Error!", "Order failed to transfer: " + resp.message);
  //     } catch (error) {
  //       showErrorToast("Error!", "Order failed to transfer!");
  //     }
  //   }
  // };

  const handlePrintOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) {
      if (window.confirm(`Do you want to show the price of this Order?`)) {
        const resp = await PrintSalesOrderApi(order.so_id, true);
        if (!resp) showErrorToast("Error!", "Record not found!");
      } else {
        const resp = await PrintSalesOrderApi(order.so_id, false);
        if (!resp) showErrorToast("Error!", "Record not found!");
      }
    } else showInfoToast("Info!", "Please select Order to print!");
  };

  // const handlePrintPLClick = async (event) => {
  //   TimeoutUtility.resetTimeout();
  //   event.preventDefault();
  //   if (order) {
  //     const resp = await PrintPackingListApi(order.so_id);
  //     if (!resp) showErrorToast("Error!", "Record not found!");
  //   } else showInfoToast("Info!", "Please select Order to print packing list!");
  // };

  // const handlePrintPFClick = async (event) => {
  //   TimeoutUtility.resetTimeout();
  //   event.preventDefault();
  //   if (order) {
  //     let value1 = order.so_id;
  //     let value2 = prompt("Enter Other Notes for Performa Invoice:");
  //     const resp = await PrintProformaInvoiceApi(order.so_id, value1, value2);
  //     if (!resp) showErrorToast("Error!", "Record not found!");
  //   } else showInfoToast("Info!", "Please select Order to print packing list!");
  // };

  const handleViewSaleClick = () => {
    TimeoutUtility.resetTimeout();
    if (order) window.open(`/Sales/ViewSalesOrder/${order.so_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Order!");
  };

  const handleRowSelected = (args) => setOrder(args?.data || null);

  // useEffect(() => {
  //   async function fetchData() {
  //     await GetAllStores()
  //       .then((resp) => {
  //         const storeOpt = resp.data.map((item) => ({
  //           label: item.name,
  //           value: item.store_id,
  //         }));
  //         setStoreOptions(storeOpt || []);
  //       })
  //          .catch((err) => console.log(err.message))
  //   }
  //   fetchData();
  // }, []);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllSalesByStoreID(storeG.store_id, "S");
      setAllOrders(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        trackPromise(
          GetAllSalesByStoreID(storeG.store_id, "S")
            .then((result) => setAllOrders(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Orders" title="SALES ORDERS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(29) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddOrderClick} />
            </Col>
          )}
          {userPermID.includes(30) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditOrderClick} />
              </Col>
              {/* <Col md="auto p-0">
                <Button text="Transfer SO" onClick={handleTransferOrderClick} />
              </Col> */}
              <Col md="auto p-0">
                <Button text="Close SO" onClick={handlestatusClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="System Build" onClick={handleBuildSheetClick} />
              </Col>
            </>
          )}
          {userPermID.includes(28) && (
            <>
              <Col md="auto p-0">
                <Button text="Print" onClick={handlePrintOrderClick} />
              </Col>
              {/* <Col md="auto p-0">
                <Button text="Packing List" onClick={handlePrintPLClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Proforma Invoice" onClick={handlePrintPFClick} />
              </Col> */}
            </>
          )}
        </Row>
        {/* <PopupSelectField
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onSelect={(store) => handleTransferOrderStore(store)}
          options={storeOptions}
          // initialValue={someDefault}
          // title="Pick Your Location"
          // message="We need this to show nearby offers."
        /> */}
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllOrders}
        cols={customersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(28) && handleViewSaleClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Sales;
